import { Component, OnInit, OnChanges } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario81',
  templateUrl: './formulario81.component.html',
  styleUrls: ['./formulario81.component.css']
})
export class Formulario81Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public registro_bienes;
  public tipo_autorizacion;
  public cip;
  public profesionalComp;
  public empresas;
  public permiso_demolicion;
  

   pages = [1,2,3];

  constructor() {

  


  }

   ngOnInit(){

   }

   ngAfterContentChecked(){


    this.ngAfterContentInit();
    
  }


   ngAfterContentInit() {
    
  
    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }
    }

    //PROPIETARIOS
    if(JSON.parse(localStorage.getItem("propietarios"))){
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
     }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }
    }

     //PERMISO NOTARIADO
    if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
    }

    //TIPO AUTORIZACION
    if(JSON.parse(localStorage.getItem("tipo_autorizacion"))){
      if (JSON.parse(localStorage.getItem("tipo_autorizacion")).length > 0){
        this.tipo_autorizacion = JSON.parse(localStorage.getItem("tipo_autorizacion"));
      }else{
       localStorage.setItem("tipo_autorizacion", JSON.stringify([]))
        this.tipo_autorizacion = [{autorizacion:''}]
      }
    }
    
    //CIP
    if(JSON.parse(localStorage.getItem("cip"))){
      if (JSON.parse(localStorage.getItem("cip")).length > 0){
        this.cip = JSON.parse(localStorage.getItem("cip"));
      }else{
       localStorage.setItem("cip", JSON.stringify([]))
        this.cip = [{certcip:'', fecha_cip:''}]
      }
    }
    
    //REGISTRO DE BIENES
    if(JSON.parse(localStorage.getItem("registro_bienes"))){
      if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0){
        this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
      }else{
       localStorage.setItem("registro_bienes", JSON.stringify([]))
        this.registro_bienes = [{inscrito:'', numero:'',anio:'',bienes:''}]
      }
    }

    //PROFESIONAL COMPETENTE
    if(JSON.parse(localStorage.getItem("profesionalComp"))){
      if (JSON.parse(localStorage.getItem("profesionalComp")).length > 0){
        this.profesionalComp = JSON.parse(localStorage.getItem("profesionalComp"));
      }else{
       localStorage.setItem("profesionalComp", JSON.stringify([]))
        this.profesionalComp = [{rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''}]
      }
    }
    
    //EMPRESAS
    if(JSON.parse(localStorage.getItem("empresas"))){
      if (JSON.parse(localStorage.getItem("empresas")).length > 0){
        this.empresas = JSON.parse(localStorage.getItem("empresas"));
      }else{
       localStorage.setItem("empresas", JSON.stringify([]))
        this.empresas = [{rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''}]
      }
    }
    
    //PERMISO DEMOLICION
    if(JSON.parse(localStorage.getItem("permiso_demolicion"))){
      if (JSON.parse(localStorage.getItem("permiso_demolicion")).length > 0){
        this.permiso_demolicion = JSON.parse(localStorage.getItem("permiso_demolicion"));
      }else{
       localStorage.setItem("permiso_demolicion", JSON.stringify([]))
        this.permiso_demolicion = [{perm_numero:'', perm_fecha:'',  solicitud:''}]
      }
    }
    
    
  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });
    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }
}

